"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Badge_1 = __importDefault(require("../../Badge"));
var config_1 = require("../../config");
var Icon_1 = __importStar(require("../../Icon"));
var b = config_1.block("menu-item");
/* eslint-disable-next-line sonarjs/cognitive-complexity */
var menuItem = function (props) {
    var active = props.active, count = props.count, className = props.className, children = props.children, disabled = props.disabled, disableClick = props.disableClick, id = props.id, label = props.label, onChange = props.onChange;
    var hasChildren = children && children.length > 0;
    var cn = b({
        active: active === id || (active && children && children.map(function (item) { return item.id; }).indexOf(active) !== -1),
        disabled: disabled,
        submenu: hasChildren,
    }).mix(className);
    var clickHandler;
    if (!disableClick) {
        clickHandler = function (event) {
            // try to find parent by given className, return null if not found
            var parentByClassName = function (el, parentClassName) {
                while (!el.className || el.className.indexOf(parentClassName) === -1) {
                    el = el.parentNode;
                    if (!el) {
                        return null;
                    }
                }
                /* eslint-disable-next-line @typescript-eslint/no-unsafe-return */
                return el;
            };
            // prevent click action if comes from submenu
            if (parentByClassName(event.nativeEvent.target, "emankit__submenu") !== null) {
                return;
            }
            if (onChange) {
                onChange(id);
            }
        };
    }
    // Render descendants
    var descendants;
    var child = 0;
    var icon;
    if (children && hasChildren) {
        var items = children.map(function (item) {
            var customClick = function (_event) {
                if (onChange) {
                    onChange(item.id);
                }
            };
            return (react_1.default.createElement("li", { key: "child_" + child++, className: active === item.id ? "active" : "" },
                react_1.default.createElement("a", { onClick: customClick },
                    item.label,
                    item.count && item.count > 0 ? react_1.default.createElement(Badge_1.default, { className: "count" }, item.count) : null)));
        });
        descendants = react_1.default.createElement("ul", { className: b("submenu") }, items);
        icon = react_1.default.createElement(Icon_1.default, { icon: Icon_1.IconType.ArrowSubmenu, width: 10, height: 6 });
    }
    // Using title + css:after element is not (as it might be) ugly hack, to preserve
    // button width after normal -> bold font-weight
    return (react_1.default.createElement("div", { onClick: clickHandler, className: cn, title: label },
        react_1.default.createElement("span", { className: "menu-text" }, label),
        count && count > 0 ? react_1.default.createElement(Badge_1.default, { className: "count" }, count) : null,
        icon,
        descendants));
};
exports.default = menuItem;
//# sourceMappingURL=index.js.map